// @ts-nocheck
import { get } from "@insite/client-framework/Services/ApiService";
import { CountriesWebsitesApiResponse, CountryWebsiteModel } from "@store/Framework/Types/CountryWebsiteModel";

const getCountriesWebsitesUrl = "api/v1/country-website/all";

export async function getCountriesWebsites(): Promise<CountryWebsiteModel[]> {
    const response = await get<CountriesWebsitesApiResponse>(`${getCountriesWebsitesUrl}`);
    return response.countriesWebsite;
}
